module.exports = __webpack_public_path__ + "img/PD1505107310098382848.c74b8b7a.png";